import { cn } from '@rocco/utils/cn';
import { BASE_STYLE } from './style';

/**
 * Displays detailed information about a professional including their summary and contact options
 */

interface ProfileDetailsProps {
    name: string;
    summary?: string;
    licenseNumber?: string;
    professionalCountry?: string;
}

export const ProfileDetails = ({
    name,
    summary,
    licenseNumber,
    professionalCountry,
}: ProfileDetailsProps) => {
    // Split name into first and last name
    const nameParts = name.split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    // Get the appropriate license number label based on the professional's country
    const getLicenseNumberLabel = () => {
        switch (professionalCountry) {
            case 'NZ':
                return 'NZRAB';
            case 'AU':
                return 'AACA';
            default:
                return 'LICENSE NUMBER';
        }
    };

    const licenseNumberLabel = getLicenseNumberLabel();

    return (
        <div
            className={cn(BASE_STYLE.TRANSITION_STANDARD, 'w-full opacity-100')}
        >
            <div className={cn('my-0 mb-1 mt-10 w-full')}>
                {licenseNumber && (
                    <p
                        className={cn(
                            BASE_STYLE.TEXT_BASE,
                            'mb-0 text-gray-500'
                        )}
                    >
                        Registered Architect {licenseNumberLabel} Reg. No.{' '}
                        {licenseNumber}
                    </p>
                )}
                <h2
                    className={cn(
                        BASE_STYLE.TEXT_HEADING,
                        BASE_STYLE.TRANSITION_FAST,
                        'mb-0'
                    )}
                    style={BASE_STYLE.INLINE_STYLES.FADE_IN_FAST}
                >
                    Meet {firstName}
                </h2>
                <h2
                    className={cn(
                        BASE_STYLE.TEXT_HEADING,
                        BASE_STYLE.TRANSITION_STANDARD,
                        'mt-0'
                    )}
                    style={BASE_STYLE.INLINE_STYLES.FADE_IN_STANDARD}
                >
                    {lastName}
                </h2>
            </div>

            <div>
                <p
                    className={`${BASE_STYLE.TEXT_BASE} ${BASE_STYLE.TRANSITION_SLOW} mb-5 mt-5 h-fit w-full break-words text-xl`}
                    style={BASE_STYLE.INLINE_STYLES.FADE_IN_SLOW}
                >
                    {summary || ''}
                </p>
            </div>
        </div>
    );
};
